import React, { useRef } from 'react';
import { Stack, Card, IconButton } from '@mui/material';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import DataSaverOnOutlinedIcon from '@mui/icons-material/DataSaverOnOutlined';
import { usePageView } from 'src/hooks/use-page-view';
import { useTranslation } from 'react-i18next';
import { tokens } from 'src/locales/tokens';
import { useRouter } from 'src/hooks/use-router';
import { paths } from 'src/paths';
import TitleButton from 'src/components/ui/headers/title-button';
import { nextNavigate } from 'src/utils/navigation-utils';
import OrdersView from '../teachers/orders/views';
import PageSection from 'src/layouts/page-section';

const Page = ({ orders }) => {
  const rootRef = useRef(null);
  const { t } = useTranslation();
  const router = useRouter();

  usePageView();

  const handleTmsClick = () => {
    router.push(paths.tms.index);
  };

  const handleOrderClick = () => {
    nextNavigate(
      router,
      null,
      paths.orders.details,
      paths.dashboard.index,
    );
  };

  return (
    <PageSection title="Overview" rootRef={rootRef}>
      <Stack spacing={1}>
        <TitleButton
          // label={t(tokens.nav.overview)}
          onButtonClick={handleTmsClick}
          name={t(tokens.nav.tms)}
          icon={AccessTimeOutlinedIcon}
          // Cheat code for hide feature
          // extraContent={
          //   <IconButton 
          //     disableRipple
          //     onClick={handleOrderClick}
          //     sx={{ color: 'primary.main', width: 44, height: 44 }}>
          //     <DataSaverOnOutlinedIcon sx={{ fontSize: 36 }} />
          //   </IconButton>
          // }
          sx={{ mr: 3 }}
        />
        <Card>
          <OrdersView myOrders={orders} />
        </Card>
      </Stack>
    </PageSection>
  );
};

export default Page;
